// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum TemplateGenericType {
	Container = 1,
	TextOnly = 2,
	InlineStyles = 3,
}
